import { Box, Image } from 'native-base';
import React from 'react';
import { ImageStyle } from 'react-native-web';
import { Caption } from '~/shared/Typography';
import { Brand, useDutchieStore, useTheme } from '@springbig/shared';
import { Button } from '~/shared/Theme';

export type BrandsCardProps = {
    brand: Brand;
    onSelectBrand?: () => void;
};

type ExtendedImageStyle = ImageStyle & { clipPath?: string };

const ImageStyles: ExtendedImageStyle = {
    clipPath: 'circle(50%)',
};

export const BrandsCard = ({
    brand,
    onSelectBrand,
}: BrandsCardProps) => {

    const {
        button_primary,
        button_text,
    } = useTheme();

    const { isBusy } = useDutchieStore();

    return (
        <Button
            variant={'text'}
            modifier={'unlocked'}
            disabled={isBusy}
            onPress={onSelectBrand}
        >
            { brand.imageUrl ?
                <Image
                    src={brand.imageUrl + '?w=130&h=130'}
                    w={'96px'}
                    h={'96px'}
                    resizeMode={'cover'}
                    style={ImageStyles}
                />
                :
                <Box
                    mx={4}
                    alignItems={'center'}
                    justifyContent={'center'}
                    w={'96px'}
                    h={'96px'}
                    rounded={'full'}
                    borderWidth={3}
                    borderColor={button_primary}
                    bg={button_text}
                    my={'auto'}
                >
                    <Caption
                        px={1}
                        noOfLines={2}
                        fontSize={14}
                        fontWeight={'600'}
                        color={button_primary}
                        textAlign={'center'}
                    >
                        { brand.name }
                    </Caption>
                </Box>
            }
        </Button>
    );
};
